import { Snippet, SnippetType } from '@distribute/shared/types';
import { ALL_OWNERS } from '../../../features/team-members'; // TODO: Fix that

import { FILTER_SNIPPET_ITEMS } from '../config';

export const getFilteredSnippetsByOwner = (
  snippets: Snippet[],
  ownerId: string
) => {
  return ownerId === ALL_OWNERS
    ? snippets
    : snippets.filter((snippet) => snippet.owner?.id === ownerId);
};

export const getFilteredSnippetsByType = (
  snippets: Snippet[],
  filter: keyof typeof FILTER_SNIPPET_ITEMS
) => {
  switch (filter) {
    case 'text':
      return snippets.filter(({ type }) => type === SnippetType.TEXT);
    case 'image':
      return snippets.filter(({ type }) => type === SnippetType.IMAGE);
    case 'video':
      return snippets.filter(({ type }) => type === SnippetType.VIDEO);
    case 'file':
      return snippets.filter(({ type }) => type === SnippetType.FILE);
    default:
      return snippets;
  }
};
